import React, { useMemo } from 'react';
import { ExarePriceDetailsPriceElementType } from '@websky/graphql';
import { useTranslation } from 'react-i18next';
import { getTotalPriceFilteredElements, getZeroPrice } from '../../utils';
import ShortDetails from '../ShortDetails/ShortDetails';
import { isFareElement, isTaxesAgency, isTaxesRetention } from './utils';
const ExtendedDetails = ({ prices, className }) => {
    const { t } = useTranslation('Refund');
    const details = useMemo(() => {
        var _a, _b, _c, _d, _e;
        const items = [];
        const priceDetails = prices.priceDetails;
        const currentCurrency = (_a = prices.basePrice) === null || _a === void 0 ? void 0 : _a.currency;
        const airticketFare = ((_b = priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.refunded.elements) === null || _b === void 0 ? void 0 : _b.find(isFareElement)) ||
            ((_c = priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.retention.elements) === null || _c === void 0 ? void 0 : _c.find(isFareElement));
        const agencyTaxes = (_d = priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.retention.elements) === null || _d === void 0 ? void 0 : _d.filter(isTaxesAgency);
        const retentionTaxes = (_e = priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.retention.elements) === null || _e === void 0 ? void 0 : _e.filter(isTaxesRetention);
        items.push({
            name: `${t('Ticket price')}:`,
            price: prices.basePrice || getZeroPrice(currentCurrency)
        });
        items.push({
            name: `${t('Airticket fare')}:`,
            price: (airticketFare === null || airticketFare === void 0 ? void 0 : airticketFare.money) || getZeroPrice(currentCurrency)
        });
        agencyTaxes === null || agencyTaxes === void 0 ? void 0 : agencyTaxes.forEach(tax => {
            items.push({
                name: t(`${tax.taxCode}_taxesAgency`, {
                    defaultValue: t('{{taxCode}} air ticket processing fee (non-refundable)', { taxCode: tax.taxCode })
                }),
                price: tax.money || getZeroPrice(currentCurrency),
                isMinus: true
            });
        });
        retentionTaxes === null || retentionTaxes === void 0 ? void 0 : retentionTaxes.forEach(tax => {
            items.push({
                name: t(`${tax.taxCode}_taxesRetention`, {
                    defaultValue: t('{{taxCode}} return processing fee', { taxCode: tax.taxCode })
                }),
                price: tax.money || getZeroPrice(currentCurrency),
                isMinus: true
            });
        });
        items.push({
            name: t('Cost of refundable services'),
            price: getTotalPriceFilteredElements(priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.refunded.elements, ExarePriceDetailsPriceElementType.gdsServiceFare, currentCurrency)
        });
        items.push({
            name: t('Cost of non-refundable services'),
            price: getTotalPriceFilteredElements(priceDetails === null || priceDetails === void 0 ? void 0 : priceDetails.retention.elements, ExarePriceDetailsPriceElementType.gdsServiceFare, currentCurrency),
            isMinus: true
        });
        return items;
    }, [t, prices]);
    console.log(details);
    return React.createElement(ShortDetails, { className: className, prices: prices, items: details });
};
export default ExtendedDetails;
